import { buildCommissionDetailsCard } from '../../shared';

export const commissionDetailsCard = buildCommissionDetailsCard({
  label: 'Landlord Agent’s Compensation',
  additionalLabel: 'Additional Landlord Agent’s Compensation',
  typeLabel: 'Landlord Agent’s Compensation Type',
});
